import { SurchargeType } from '../config/i18nConfig'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'
import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'

type ReturnProps = {
    loaded: boolean
    surchargeTypes: SurchargeType[]
    getSurchargeType: (id: string) => SurchargeType
    getSurchargeTypeName: (id: string) => string
}

export default function useSurchargeTypes(): ReturnProps {
    const { i18n } = useTranslation()
    const { entities, loaded } = useGlobalContext('surchargeTypes')

    const surchargeTypes: SurchargeType[] = useMemo(
        () => entities?.sort((a, b) => (a.position || 1000) - (b.position || 1000)) || [],
        [entities],
    )

    const getSurchargeType = (id: string) => surchargeTypes.find(value => value.id === id)
    const getSurchargeTypeName = (id: string) =>
        getI18NName(
            surchargeTypes.find(value => value.id === id),
            i18n.language,
        )

    return { loaded, surchargeTypes, getSurchargeType, getSurchargeTypeName }
}
